<template>
    <div
        class="lo header"
        :class="transparent? 'is-transparent': ''"
    >
        <div class="g header-01">
            <div class="md pre-page" >
                <a @click.prevent.stop="prePage">
                    <span class="name"></span>
                </a>
            </div>
            <mdLogo></mdLogo>
            <div class="g header-02">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import mdLogo from '@/components/mdLogo'

    export default {
        components: {
            mdLogo
        },
        props: {
            transparent: {
                type: Boolean,
                require: false,
                default: false,
            },
        },
        computed: {
            mobileMode: function(){ //如果是手機就不變化
                return this.$okaTool.checkMobile();
            },
         
        },
        methods: {
            prePage: function(){
               this.$emit('sendEvent', 'prepage')
            }
        }
        
    }
</script>

<style scoped lang="scss">

    .lo.header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        box-sizing: border-box;
        padding: $interval-m;
        transition: $transition;
        z-index: 7;

        &.is-transparent {

            &::before {
                opacity: 0;
            }
        }

        &::before {
            transition: 600ms;
            content: $content;
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            // background-color: rgba($major-color, $opacity-h);
            background-image: linear-gradient(to bottom, $major-color 0, rgba-set($major-color, $opacity-h) 100%);
            backdrop-filter: saturate(120%) blur(4px);
            z-index: -1;
        }

        &::after {
            @extend %clear;
        }

        .g.header-01 {
            display: flex;
            max-width: $pc-width;
            margin: 0 auto;

            .md.pre-page{
                @extend %header-btn;
                display: none;

                @include media('phone') {
                    display: block;
                }

                > a {
                    padding-right: $interval-l;

                    @include media('mobile') {
                        padding-right: 0;
                        border-width: 0;
                        // border-radius: $border-radius;
                        background-color: transparent;
                    }

                    &::before {

                        @include media('mobile') {
                            content: '\e5c4';
                            margin-right: $interval-s;
                        }
                    }

                    .name {

                        @include media('mobile') {
                            display: none;
                        }
                    }
                }
            }
        }

        .g.header-02 {
            
        }
    }

</style>
